import { IonSpinner, useIonRouter, useIonViewWillLeave, IonGrid, IonText, IonImg, IonBadge, IonFab, IonFabButton, IonRefresherContent, IonRefresher, IonSegmentButton, IonSegment, useIonViewWillEnter, IonInfiniteScrollContent, IonInfiniteScroll, IonSearchbar, IonBackButton, IonButton, IonButtons, IonCard, IonCheckbox, IonCol, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonPage, IonRow, IonTitle, IonToolbar } from "@ionic/react";
import { people, createOutline } from "ionicons/icons";
import React, { useState, useEffect } from "react";
import { logoWebComponent, addOutline } from "ionicons/icons";

import { Storage } from '@capacitor/storage';   
import NServer, { UIElement } from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import { showTab, updateTab } from "../components/Tabs";
import Vault from '../components/Vault';
import { ItemInfo } from '../data/item';
import ItemComp from "../components/ItemComp";

import './Main.css';  

var index = 0;
const total = 25;
var noRefresh = false;

const Messages : React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [noMoreLoadData, setNoMoreLoadData] = useState(false);
    const [view, setView] = useState("friend");
    
    const [followers, setFollowers] = useState<ItemInfo[]>([]);
    const [followerAll, setFollowerAll] = useState<ItemInfo[]>([]);

    const [friendNoti, setFriendNoti] = useState(0);
    const [followedNoti, setFollowedNoti] = useState(0);
    const [followerNoti, setFollowerNoti] = useState(0);
    
    const router = useIonRouter();

    useIonViewWillEnter(() => {
        index = 0;
        setView("friend");
    });

    useIonViewWillLeave(() => {
    });

    useEffect( ()=> { getData() }, [view]);
    
    // when search text is changed
    useEffect(() => {
        // filter here
        let query = searchText.toLowerCase();
        console.log("Searching-> " + query);
        if (query == "")
        {
            setNoMoreLoadData(false);
            noRefresh = false;
            setFollowers(followerAll);
        }
        else
        {
            setNoMoreLoadData(true);
            noRefresh = true;
            setFollowers(followerAll.filter(d => (d.name.toLowerCase().indexOf(query) > -1)));
        }
    }, [searchText]);

    const getData = async () => {

        let v = new Vault();
        await v.read();

        setLoading(true);

        const state = {
            id: v.account.id,
            pass: v.account.key,
            search: searchText,
            type: view,
            s : index,
            e : total
        }

        if (noRefresh)
            return;

        var server = new NServer();

        await server.getList("nc_followers", state);
        if (server.success)
        {
            let stream = server.data.followers;

            if (index != 0)
                stream = followerAll.concat(server.data.followers);

            setFollowers(stream);
            setFollowerAll(stream);

            console.log("Loading-> " + noRefresh);

            if (server.data.followers.length < total)
                setNoMoreLoadData(true);

            setFriendNoti(server.data.friend_noti);
            setFollowedNoti(server.data.followed_noti);
            setFollowerNoti(server.data.follower_noti);
        }

        setLoading(false);
	}

    const doRefresh = async (ev : any) => {
        // start from beginning
        setNoMoreLoadData(false);
        index = 0;
        
        await getData();
        ev.detail.complete();
    };

    const loadMoreData = (ev: any) => {
        setTimeout(() => {
            // increase index
            index += total;

            getData();

            ev.target.complete();
        }, 500);
    }  

    const doSearch = async (term : string) => {
        setSearchText(term);
    }

    const changeView = (v : string) => {
        index = 0;
        noRefresh = false;
        setFollowers([]);
        setNoMoreLoadData(false);

        setView(v);
    }

    // click on user
    const onClick = (item : ItemInfo) => {
        router.push("/user/" + item.id, "forward", "push");
    }

    return (
        <IonPage>
            <IonContent>
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonSegment value={view} onIonChange={ (e) => { changeView(e.detail.value!) }}>
                    <IonSegmentButton value="friend">
                        <IonLabel color={ view=="friend" ? "primary" : "medium" }><b><small>{ GetStr(LANGUAGE.TXT_TAB_FRIENDS) }</small></b></IonLabel>
                        {
                            friendNoti > 0 ?
                        <IonBadge className="noti-bottom">{ friendNoti }</IonBadge>
                            :
                        <div />
                        }
                    </IonSegmentButton>
                    <IonSegmentButton value="followed">
                        <IonLabel color={ view=="followed" ? "primary" : "medium" }><b><small>{ GetStr(LANGUAGE.TXT_TAB_FOLLOWED) }</small></b></IonLabel>
                        {
                            followedNoti > 0 ?
                        <IonBadge className="noti-bottom">{ followedNoti }</IonBadge>
                            :
                        <div />
                        }
                    </IonSegmentButton>
                    <IonSegmentButton value="follower">
                        <IonLabel color={ view=="follower" ? "primary" : "medium" }><b><small>{ GetStr(LANGUAGE.TXT_TAB_FOLLOWERS) }</small></b></IonLabel>
                        {
                            followerNoti > 0 ?
                        <IonBadge className="noti-bottom">{ followerNoti }</IonBadge>
                            :
                        <div />
                        }
                    </IonSegmentButton>
                </IonSegment>
                <IonToolbar color="none">
                    <IonSearchbar className="search-bubble" placeholder={ GetStr(LANGUAGE.TXT_CHAT_SEARCH) } value={searchText} onIonChange={ (e) => { doSearch(e.detail.value!)}} ></IonSearchbar>
                </IonToolbar>
                {
                    followers.length > 0 ?
                <IonCard className="flat-card">
                    <IonList>
                        {followers.map(m => <ItemComp key={m.id} item={m} onSubmit={onClick} />)}
                    </IonList>

                    <IonInfiniteScroll
                        onIonInfinite={loadMoreData}
                        disabled={noMoreLoadData}
                    >
                        <IonInfiniteScrollContent
                            className="ion-no-padding"
                            loadingSpinner="crescent"
                        ></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                </IonCard>
                    :
                    loading ?
                <div className="spinnerLogin">
                    <IonSpinner name="crescent" />
                </div>
                    :
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-text-center" size-md="8" size-lg="6" size-xl="4" size="10">
                            <div><IonText>
                                <h4>{ GetStr(view == "friend" ? LANGUAGE.TXT_CAP_NO_FRIEND : ( view == "followed" ? LANGUAGE.TXT_CAP_NO_FOLLOWED : LANGUAGE.TXT_CAP_NO_FOLLOWER )) }</h4>
                            </IonText></div>
                            <div><IonImg className="info-pic" src="/assets/img/empty_pic.png" /></div>
                            <div>
                                <IonText>{ GetStr(view == "friend" ? LANGUAGE.TXT_DESC_NO_FRIEND : ( view == "followed" ? LANGUAGE.TXT_DESC_NO_FOLLOWED : LANGUAGE.TXT_DESC_NO_FOLLOWER )) }</IonText>
                            </div>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                }
            </IonContent>
        </IonPage>
    );
};
export default Messages;